<script setup lang="ts">
import type { NavigationLinkFragment, NavigationTreeFragment } from '#graphql-operations'

interface SubmenuSimpleProps {
  submenu: NavigationTreeFragment
}

const props = defineProps<SubmenuSimpleProps>()

const hasChildren = computed(() => (props.submenu.children?.length || 0) > 0)
</script>

<template>
  <li class="submenuSimple col-span-3">
    <div v-if="hasChildren" class="mb-10 space-y-1.5">
      <p class="typo-serif-2">
        {{ submenu.title }}
      </p>
      <ButtonLink :title="submenu.badge" :to="submenu.url">
        <template #icon>
          <i class="i-icon-arrow-right flex-none size-7.5 icon" />
        </template>
      </ButtonLink>
    </div>
    <ButtonNavSubmenu v-else :link="submenu" />
    <ul v-if="hasChildren" class="space-y-1.5">
      <li v-for="link in (submenu.children as NavigationLinkFragment[])" :key="link.id" class="flex">
        <ButtonNavSubmenu :link />
      </li>
    </ul>
  </li>
</template>
